"use strict";
exports.__esModule = true;
exports.RadioGroup = void 0;
var RadioContext_1 = require("./RadioContext");
var RadioGroup_1 = require("./RadioGroup");
var RadioOption_1 = require("./RadioOption");
var RadioGroup = Object.assign(RadioGroup_1.RadioGroup, {
    Option: RadioOption_1.RadioOption,
    Context: RadioContext_1.RadioContext
});
exports.RadioGroup = RadioGroup;
//# sourceMappingURL=index.js.map